export default __webpack_public_path__ + "static/media/MilanBalaban.25219996.png";